import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global error handler to suppress IndexedDB and Supabase lock errors
window.addEventListener('error', (event) => {
  // Check if it's an IndexedDB lock error or Supabase lock error
  if (event.error && 
      (event.error.name === 'AbortError' || 
       event.error.message?.includes('Lock broken') ||
       event.error.message?.includes('steal') ||
       event.error.message?.includes('this.lock is not a function') ||
       event.error.message?.includes('_acquireLock'))) {
    console.warn('Storage lock error suppressed:', event.error.message);
    event.preventDefault(); // Prevent error from showing in console
    return true;
  }
});

// Global unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
  // Check if it's an IndexedDB lock error or Supabase lock error
  if (event.reason && 
      (event.reason.name === 'AbortError' || 
       event.reason.message?.includes('Lock broken') ||
       event.reason.message?.includes('steal') ||
       event.reason.message?.includes('this.lock is not a function') ||
       event.reason.message?.includes('_acquireLock'))) {
    console.warn('Storage lock promise rejection suppressed:', event.reason.message);
    event.preventDefault(); // Prevent unhandled rejection warning
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
